// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../graphql/api/index';

import { gql } from 'graphql-tag';
import { BlockAnchorFragmentDoc } from './BlockAnchor.fragment.generated';
import { ComponentFragmentDoc } from './CmsComponent.fragment.generated';
import { ComponentGlobalComponentFragmentDoc } from './component/ComponentGlobalComponent.fragment.generated';
export const BlockFragmentDoc = gql`
    fragment block on Block {
  width
  backgroundColor
  backgroundOverflow
  verticalSpacing
  display
  anchor {
    ...blockAnchor
  }
  isCollapsible
  collapsibleTitle
  isOpenByDefault
  components {
    ...component
    ... on ComponentGlobalComponent {
      ...componentGlobalComponent
    }
  }
}
    ${BlockAnchorFragmentDoc}
${ComponentFragmentDoc}
${ComponentGlobalComponentFragmentDoc}`;